// extracted by mini-css-extract-plugin
export var sbShowMain = "sidebar-module--sb-show-main--3Pbdx";
export var wrapper = "sidebar-module--wrapper--cg8LS";
export var content = "sidebar-module--content--P-01h";
export var image = "sidebar-module--image--2QvnG";
export var sectionTitle = "sidebar-module--sectionTitle--36fWC";
export var modalButton = "sidebar-module--modalButton--9XLa8";
export var modalBody = "sidebar-module--modalBody--1UzZE";
export var subscribe = "sidebar-module--subscribe--1MfbY";